import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
@Component({
  standalone: false,
  selector: 'app-verification-success',
  templateUrl: './verification-success.component.html',
  styleUrls: ['./verification-success.component.scss']
})
export class VerificationSuccessComponent implements OnInit {
  private backButtonAttempts = 0;

  constructor(
    private readonly router: Router,
    private location: LocationStrategy
  ) {
    // Prevent browser back button navigation
    this.preventBackButton();
  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   // this.router.navigate(['/my-app?isNew']);
    //   this.router.navigate(['/pages/my-app'], { queryParams: { isNew: 'true' } });
    // }, 5000);
  }

  goToLogin() {
    this.router.navigate(['/login'], { queryParams: { isNew: 'true' } });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any): void {
    this.backButtonAttempts++;
    
    if (this.backButtonAttempts === 1) {
      alert('The browser Back button has been disabled. Please use our website\'s navigation menu options.');
      
      history.pushState(null, null, this.router.url);
    } else {
      alert('For security reasons, you will be redirected to the login page.');
      this.router.navigate(['/login']);
    }
  }
  private preventBackButton(): void {
    for (let i = 0; i < 3; i++) {
      history.pushState(null, null, window.location.href);
    }
    
    this.location.onPopState(() => {
      setTimeout(() => {
        if (this.backButtonAttempts >= 2) {
          this.router.navigate(['/login']);
        } else {
          history.pushState(null, null, window.location.href);
        }
      }, 50);
    });
  }
  
}
